import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { pick } from 'lodash';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { getNumberFromString, getNumbersArray } from 'helpers/numbers';

import { FundingDirectionChart } from '../../common/FundingDirectionChart';
import { InfoCard } from '../components/InfoCard';

import styles from './FinancingNeedsSection.module.scss';

export const FinancingNeedsSection: React.FC = () => {
  const { data } = useDataContext();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.financingNeeds);

  const cardsData = pick(data, ['totalCost', 'fundingAmount', 'percentageOfFunding']);

  const shouldRenderCards = Boolean(getNumbersArray(Object.values(cardsData) as string[]).filter(Boolean).length);

  const shouldRenderFundingDirectionChart =
    data.financingNeedsChart &&
    Object.values(data.financingNeedsChart).some((item) => Boolean(item.currencyAmount) && item.currencyAmount !== '0');

  if (!shouldRenderFundingDirectionChart && !shouldRenderCards) {
    return null;
  }
  return (
    <Box {...registerNavSection} className={clsx(styles.wrapper, styles.section)}>
      <Box className={styles.title}>{t('financingNeeds')}</Box>
      <Box className={styles.container}>
        {shouldRenderFundingDirectionChart && (
          <Box className={styles.chartWrapper}>
            <FundingDirectionChart
              variant={STYLE_VARIANTS.OUTLINED}
              data={data.financingNeedsChart!}
              title={<Typography variant="h4">{t('onePageMapping.fundingDirections')}</Typography>}
            />
          </Box>
        )}
        <Box className={styles.cardsContainer}>
          {data.totalCost && Boolean(getNumberFromString(data.totalCost)) && (
            <InfoCard label={t('onePageMapping.totalProjCost')} value={data.totalCost} variant="green" />
          )}
          {data.fundingAmount && Boolean(getNumberFromString(data.fundingAmount)) && (
            <InfoCard label={t('onePageMapping.fundingNeeds')} value={data.fundingAmount} variant="green" />
          )}
          {data.percentageOfFunding && Boolean(getNumberFromString(data.percentageOfFunding)) && (
            <InfoCard label={t('onePageMapping.fundingByOwnFunds')} value={data.percentageOfFunding} variant="green" />
          )}
        </Box>
      </Box>
    </Box>
  );
};
